import type { SVGProps } from "react";

export default function CircleCrossIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="1.25" />
      <path
        d="M7 7L13 13M13 7L7 13"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </svg>
  );
}
